import React from "react";
import { Box, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import TopBarNavigation from "../components/navigation/TopBarNavigation";
import Footer from "../components/Footer";

const PublicWrapper = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100vw",
        overflow: "hidden",
        //bgcolor: "background.default",
      }}
    >
      {/* 1. Fixed TopBar */}
      <Box sx={{ flexShrink: 0, zIndex: theme.zIndex.appBar }}>
        <TopBarNavigation />
      </Box>

      {/* 2. Scrollable Content Area */}
      <Box
        component="main"
        sx={{
          flex: 1, // Takes all available space
          overflowY: "auto", // Scroll happens here
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Outlet />
      </Box>

      {/* 3. Fixed Footer (Optional: remove flexShrink to make it scroll with content) */}
      <Box sx={{ flexShrink: 0, zIndex: theme.zIndex.appBar }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default PublicWrapper;
